// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xga_","left":"styles_left__3xx5K","desktopActions":"styles_desktopActions__1hKQc","title":"styles_title__Zk7wu"};